import * as React from 'react';

function SvgPay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
      <path d="M6.15 6h20.7c.64 0 1.15.52 1.15 1.17v18.66c0 .65-.51 1.17-1.15 1.17H6.15C5.51 27 5 26.48 5 25.83V7.17C5 6.52 5.51 6 6.15 6zM7.3 8.33v16.34h18.4V8.33H7.3zm5.18 10.5h6.32c.32 0 .58-.26.58-.58a.58.58 0 00-.58-.58h-4.6a2.9 2.9 0 01-2.88-2.92 2.9 2.9 0 012.88-2.92h1.15V9.5h2.3v2.33h2.87v2.34H14.2a.58.58 0 00-.58.58c0 .32.26.58.58.58h4.6a2.9 2.9 0 012.87 2.92 2.9 2.9 0 01-2.87 2.92h-1.15v2.33h-2.3v-2.33h-2.88v-2.34z" />
    </svg>
  );
}

export default SvgPay;
